import React from 'react';

const TickIcon = (props) => {
  return (
    <svg style={props.style} width="16px" height="10px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg" >

      <title>Path</title>

      <g id="Case-Details" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="MIssing-Trans---Match-Success---Copied-Success" transform="translate(-513.000000, -93.000000)" fill="#5AA832">
          <g id="Alert-Notification-v3---success-Copy" transform="translate(420.000000, 0.000000)">
            <path d="M108.257129,95.4164879 C108.559452,95.1141653 108.559452,94.6239556 108.257129,94.3216331 L107.162274,93.2267782 C106.859952,92.9244073 106.369742,92.9244073 106.067371,93.2267782 L98.8064516,100.487649 L95.4165,97.0976976 C95.1141774,96.795375 94.6239677,96.795375 94.3215968,97.0976976 L93.2267419,98.1925524 C92.9244194,98.494875 92.9244194,98.9850847 93.2267419,99.2874073 L98.259,104.319665 C98.561371,104.622036 99.0515323,104.622036 99.3539032,104.319714 L108.257129,95.4164879 Z" id="Path" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TickIcon;
